const FallbackSpinner = () => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      {/* <img
        width={'50px'}
        src={`${LOCAL_PATH}/images/logos/paan-legal-small-logo.png`}
        alt="Paper tax logo"
      /> */}
      <div
        style={{ width: '60px', height: '60px', position: 'absolute' }}
        className="spinner-border text-primary"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default FallbackSpinner;
